import { useQuery } from '@tanstack/react-query';
import { fetchEntityDetail } from '@/api/settings';

export {
  useDashboardOrderStatistics,
  useDashboardSales,
  useDashboardUsers,
  useDashboardZones,
} from './useDashboardQueries';

export function useEntityDetail(type: string | null, id: string | number | null) {
  return useQuery({
    queryKey: ['entity-detail', type, id],
    queryFn: () => fetchEntityDetail(type!, id!),
    enabled: !!type && id != null && id !== '',
  });
}
